<template>
  <div>
    <v-card class="mb-3 px-2 py-2" v-if="user !== null">
      <h2 class="mb-3">Informations personnelles</h2>
      <v-text-field
        v-model="user.email"
        label="Adresse mail"
        v-validate="'required|email'"
        data-vv-name="email"
        :error-messages="errors.collect('email')"
      ></v-text-field>
      <v-text-field
        v-model="user.lastName"
        label="Nom de famille"
        v-validate="'required'"
        data-vv-name="lastName"
        :error-messages="errors.collect('lastName')"
      ></v-text-field>
      <v-text-field
        v-model="user.firstName"
        label="Prénom"
        v-validate="'required'"
        data-vv-name="firstName"
        :error-messages="errors.collect('firstName')"
      ></v-text-field>
      <v-text-field
        :value="cleanBirthDate"
        @input="updateDate($event)"
        label="Date de naissance (JJ/MM/AAAA)"
        data-vv-name="birthday"
        v-validate="{ required: false, regex: /^[0123]\d\/[01]\d\/\d\d\d\d$/ }"
        :error-messages="errors.collect('birthday')"
      ></v-text-field>
      <div class="d-flex justify-center">
        <v-btn color="accent" @click="save">Sauvegarder</v-btn>
      </div>
      <v-snackbar v-model="showSuccess">
        Modifications enregistrées
      </v-snackbar>
      <v-snackbar v-model="showError"> Une erreur a eu lieu </v-snackbar>
    </v-card>
  </div>
</template>
<script>
import { fetchHil } from "../../utils";
import moment from "moment";

export default {
  name: "UserInfos",

  data() {
    return {
      user: null,
      showSuccess: false,
      showError: false
    };
  },

  computed: {
    cleanBirthDate: function() {
      let v = this.user.birthday;
      if (v == null) {
        return v;
      }
      return moment(String(v)).format("DD/MM/YYYY");
    }
  },

  async mounted() {
    await this.reload();
  },

  methods: {
    async reload() {
      const resp = await fetchHil("/user/info");
      this.user = await resp.json();
    },
    updateDate(value) {
      if (!/^[0123]\d\/[01]\d\/\d\d\d\d$/.test(value)) {
        return;
      }
      this.user.birthday = moment(value, "DD/MM/YYYY").toISOString();
    },
    async save() {
      if (!this.$validator.validateAll()) {
        return;
      }
      try {
        const { email, firstName, lastName, birthday } = this.user;
        const resp = await fetchHil("/user/update", {
          method: "PUT",
          body: {
            email,
            firstName,
            lastName,
            birthday
          }
        });
        const json = await resp.json();
        localStorage.setItem("hil_token", json.token);
        if (!resp.ok) {
          throw new Error("validation failed");
        }
        this.showSuccess = true;
        this.reload();
      } catch (e) {
        console.warn(this.showError);
        this.showError = true;
      }
    }
  }
};
</script>
<style></style>
